import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import CRUDsAPI from '../../../api/CRUDs';
import { obterCargoByEmpresaId, obterNivelByEmpresaId } from '../../../api/rh';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const CreateOrEdit = () => {
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();

    const token = localStorage.getItem('token');
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const [optionsCargo, setOptionsCargo] = useState([]);
    const [optionsNivel, setOptionsNivel] = useState([]);

    const pathname = '/Plantao';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
        ...(btnText === 'Cadastrar' && { concluido: false, concluidoData: null }),
    });

    const [Plantonistas, setPlantonistas] = useState([]);

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [optionsEmpresa, setEmpresa] = useState([]);

    //carregar API's Externas
    const consultaEmpresa = async () => {
        const dados = await EmpresaAPI.empresa(empresaId);
        setEmpresa(dados);
    };

    const consultaCargo = async ({ empresaId, empresaIds }) => {
        try {
            const data = await obterCargoByEmpresaId({ empresaId, empresaIds });
            setOptionsCargo(data || []);
        } catch (error) {
            console.error(error);
            throw new Error('Erro ao buscar cargo'); // Lançar um erro amigável
        }
    };
    const consultaNivel = async (empresaId) => {
        if (!empresaId) {
            return;
        }
        try {
            const data = await obterNivelByEmpresaId({ empresaId });
            setOptionsNivel(data || []);
        } catch (error) {
            console.error(error);
            throw new Error('Erro ao buscar nível');
        }
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        consultaEmpresa(empresaId);
        consultaCargo({ empresaId, empresaIds });
        consultaNivel(empresaId);

        if (uuid && uuid !== 'null') {
            //consulta a API
            CRUDsAPI.plantao
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                    setPlantonistas(response?.data?.Plantonistas || []);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(obj) {
        let urlNavigate = pathname;
        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.plantao.editar(obj);
            } else {
                response = await CRUDsAPI.plantao.cadastrar(obj);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                pessoaId={pessoaId}
                empresaId={empresaId}
                empresaIds={empresaIds}
                parametro={parametro}
                handleSubmit={managerDados}
                btnText={btnText}
                optionsEmpresa={optionsEmpresa}
                caminhoVoltar={pathname}
                optionsCargo={optionsCargo}
                optionsNivel={optionsNivel}
                Plantonistas={Plantonistas}
                setPlantonistas={setPlantonistas}
            />
        </section>
    );
};
export default CreateOrEdit;
